import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ESpinner from 'components/others/Spinner';
import TitleCounter from 'components/others/TitleCounter';
import OffSetEdit from './OffSetEdit';
import SetToolBar from './SetToolBar';
import SetsTable from './SetsTable';
import useProductsSets from './model/useProductsSets';

const ProductsSets = () => {
    const { t } = useTranslation(['Sets', 'common']);
    const { setsList, editSetId, setEditSetId, fetchSets, filterCategoryIds, setFilterCategoryIds } = useProductsSets();

    return (
        <>
            <OffSetEdit setId={editSetId} setSetId={setEditSetId} fetchSets={fetchSets} />

            <Row>
                <Col className="col-sticky" sm={12}>
                    <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start">
                        <div>
                            <h4 className="p-0 m-0 mb-0 me-2 text-break">{t('title')}</h4>
                            <TitleCounter />
                        </div>
                        <div className="mt-2 mt-sm-0">
                            <SetToolBar
                                setEditSetId={setEditSetId}
                                filterCategoryIds={filterCategoryIds}
                                setFilterCategoryIds={setFilterCategoryIds}
                            />
                        </div>
                    </div>
                </Col>

                <Col sm={12}>
                    <div className="px-0">
                            {setsList ? (
                                <SetsTable setsList={setsList} fetchSets={fetchSets} setEditSetId={setEditSetId} />
                            ) : (
                                <ESpinner />
                            )}
                        </div>
                </Col>
            </Row>
        </>
    );
};

export default ProductsSets;
